import { TokenService } from '../../services/token.service'
import router from '../../router'
import Loader from '../../components/loader/Loader'

export default {
    name: 'Login',
    components: {
        Loader
    },

    mounted() {
        setTimeout(() => {
            if (TokenService.getToken()) {
                router.push(router.history.current.query.redirect || '/visits')
            }
        }, 1);
    }
}